export const SITE = {
  name: "Maria João Nepomuceno",
  cedula: "Cédula OA 200-M",
  office: "Rua Ivens 22, 3.º Esq., Funchal",
  email: "mjn.advogada@gmail.com",
  whatsapp: "+351 938 718 884",
  whatsappRaw: "351938718884",
  phoneHref: "tel:+351938718884",
  domain: "mariajoaonepomuceno.com",
  origin: "https://mariajoaonepomuceno.com",
};

// Real photographs of Maria João Nepomuceno (uploaded by the client).
export const PORTRAIT_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/qivwudzb_469779113_18479135782031981_1730691279528474251_n.jpg";

export const MEDIA = {
  portrait2: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/p2a5xkd2_mariajoaonepomuceno2.jpg",
  madeira: "https://images.unsplash.com/photo-1748446745193-e95f11095eb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  guideCover: "https://images.unsplash.com/photo-1611417041461-2060f649193d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office: "https://images.unsplash.com/photo-1558478551-1a378f63328e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PHOTOS = {
  father: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/6tk22egh_mariajoao1.jpeg",
  family: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/h7xnxijr_marianadsister.webp",
  sisters: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/4vp304zz_WhatsApp%20Image%202026-08-28%20at%2013.54.23.jpeg",
  posse: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/7dgfsts5_WhatsApp%20Image%202026-08-28%20at%2018.50.14.jpeg",
  toga: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/x6cvq2mw_WhatsApp%20Image%202026-08-28%20at%2018.50.33.jpeg",
  bastonario: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/s1z8dz29_WhatsApp%20Image%202026-08-28%20at%2018.51.12.jpeg",
  familyFormal: "https://customer-assets-m6fa6gv7.emergentagent.net/job_luxury-family-law/artifacts/z4smk76c_WhatsApp%20Image%202026-08-28%20at%2018.56.19.jpeg",
};

export const LEGACY_IMAGES = [
  { src: PHOTOS.father, pos: "object-center", aspect: "aspect-[4/5]" },
  { src: PHOTOS.family, pos: "object-center", aspect: "aspect-[4/5]" },
  { src: PHOTOS.sisters, pos: "object-[50%_40%]", aspect: "aspect-[4/5]" },
  { src: PHOTOS.posse, pos: "object-[50%_25%]", aspect: "aspect-[4/5]" },
  { src: PHOTOS.toga, pos: "object-[50%_20%]", aspect: "aspect-[4/5]" },
  { src: PHOTOS.bastonario, pos: "object-center", aspect: "aspect-[4/5]" },
  { src: PHOTOS.familyFormal, pos: "object-top", aspect: "aspect-square" },
];

export const GOOGLE_REVIEWS_URL = "https://share.google/v0oliCAqYG7mOgW60";

// Real Google reviews (5 stars) — extracted from the public Google Business profile.
export const REVIEWS = [
  { name: "Laura Pestana", text: "Recomendo vivamente os serviços da Dra. Maria João Nepomuceno. Desde o primeiríssimo contacto, a empatia e o acolhimento foram excecionais. É uma profissional direta e transparente em tudo o que faz, o que transmite uma enorme segurança." },
  { name: "Marcelino Gama", text: "Excelente profissional, responsável a defender os direitos dos seus clientes. Muito humana e muito cuidadosa no contacto com os seus clientes." },
  { name: "MPNDS", text: "Advogada especialista em Direito da Família, com grande experiência em responsabilidades parentais e divórcios. O que mais a distingue é a combinação entre conhecimento profundo e uma empatia extraordinária." },
  { name: "Any Maria", text: "A Dra. Maria João é, sem qualquer tipo de dúvida, a melhor advogada do mundo! Está comigo nos processos de regulação parental e nunca, em tempo algum, duvidei das suas capacidades." },
  { name: "Cíntia Fernandes", text: "Uma advogada excecional, capaz de combinar a precisão técnica com a sensibilidade humana, interpretando as leis de forma a promover justiça e equidade." },
  { name: "Bruno Miguel", text: "Uma advogada de excelência, com um impacto significativo e positivo na vida dos seus clientes. Resiliente, proativa e capaz de solucionar problemas de maneira eficaz." },
  { name: "Maria Luisa Freitas", text: "Cuidou do meu processo com muita honestidade e profissionalismo e aconselhou-me em todos os momentos. Nunca desistiu de mim e da minha filha. Grata pelo seu trabalho." },
  { name: "Ana Isabel Nepomuceno", text: "Uma advogada empenhada, competente e que acompanha os seus clientes — ou mesmo quem a procura — de forma exímia." },
];

export const PAGES = [
  { key: "home", pt: "/", en: "/en" },
  { key: "consulta", pt: "/consulta-online", en: "/en/online-consultation" },
  { key: "internacional", pt: "/direito-familia-internacional", en: "/en/international-family-law" },
  { key: "vistos", pt: "/vistos", en: "/en/visas" },
  { key: "divorcio", pt: "/divorcio", en: "/en/divorce" },
  { key: "alimentos", pt: "/pensoes-alimentos", en: "/en/child-support" },
  { key: "patrimonio", pt: "/patrimonio", en: "/en/cohabitation-assets" },
  { key: "historia", pt: "/a-minha-historia", en: "/en/my-story" },
  { key: "legado", pt: "/legado", en: "/en/legacy" },
  { key: "guia", pt: "/guia", en: "/en/guide" },
  { key: "privacidade", pt: "/privacidade", en: "/en/privacy" },
];

export const langFromPath = (pathname) =>
  pathname === "/en" || pathname.startsWith("/en/") ? "en" : "pt";

export const pageKeyFromPath = (pathname) => {
  const p = PAGES.find((pg) => pg.pt === pathname || pg.en === pathname);
  return p ? p.key : "home";
};

export const pathFor = (key, lang) => {
  const p = PAGES.find((pg) => pg.key === key);
  return p ? p[lang] : "/";
};

export const waLink = (lang) => {
  const msg =
    lang === "en"
      ? "Hello Dra. Maria João, I would like to book a consultation regarding family law."
      : "Olá Dra. Maria João, gostaria de marcar uma consulta sobre direito da família.";
  return `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(msg)}`;
};
